import React from "react";

import {Link} from "@pg-design/link-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {promotionOfferPluralize} from "@pg-mono/string-utils";

import {buildFriendlyPromotionSlug} from "../../../promotion/helpers/build_friendly_promotion_slug";
import {ISelectedRegion} from "../actions/offer_list_selected_data_actions";

interface IProps {
    selectedRegion: ISelectedRegion[];
    className?: string;
}

export const OfferListPromotionLink = React.memo((props: IProps) => {
    const promotionsCount = props.selectedRegion.length === 1 && props.selectedRegion[0].stats ? props.selectedRegion[0].stats.promotions_count_total : 0;
    const promotionListingLink = rpAppLink.promotions.listFriendly({friendlySlug: buildFriendlyPromotionSlug({region: props.selectedRegion?.[0]?.slug})});

    return (
        <>
            {" "}
            <Link href={promotionListingLink} className={props.className}>
                w tym {promotionsCount} {promotionOfferPluralize(promotionsCount)}
            </Link>
        </>
    );
});
import React from "react";

import {Link} from "@pg-design/link-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {promotionOfferPluralize} from "@pg-mono/string-utils";

import {buildFriendlyPromotionSlug} from "../../../promotion/helpers/build_friendly_promotion_slug";
import {ISelectedRegion} from "../actions/offer_list_selected_data_actions";

interface IProps {
    selectedRegion: ISelectedRegion[];
    className?: string;
}

export const OfferListPromotionLink = React.memo((props: IProps) => {
    const promotionsCount = props.selectedRegion.length === 1 && props.selectedRegion[0].stats ? props.selectedRegion[0].stats.promotions_count_total : 0;
    const promotionListingLink = rpAppLink.promotions.listFriendly({friendlySlug: buildFriendlyPromotionSlug({region: props.selectedRegion?.[0]?.slug})});

    return (
        <>
            {" "}
            <Link href={promotionListingLink} className={props.className}>
                w tym {promotionsCount} {promotionOfferPluralize(promotionsCount)}
            </Link>
        </>
    );
});
